/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByPositiveCommentKind = (typeof GroupByPositiveCommentKind)[keyof typeof GroupByPositiveCommentKind];

export const GroupByPositiveCommentKind = {
  positive_comment: 'positive_comment',
} as const;
